import { graphql } from '@graphql/gql';

export const ME_APPT_AND_GUEST_CODE = graphql(`
  query ME_APPT_AND_GUEST_CODE {
    me {
      id
      firstName
      lastName
      guest
      confirmationNumber
      event {
        appointmentEvents {
          id
          apptEventCode
          apptEventType
          status
          readOnly
        }
        start
        end
        format
      }
      permissions {
        roles {
          boothStaff
        }
      }
    }
  }
`);
